import React from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/Home";
import PagePath from "./util/RoutePagePath";
import ProductDetail from "./components/Productdetail";
import About from "./components/About";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Success from "./components/Success";
import Subscription from "./components/Subscribe";
import JoinUs from "./components/JoinUs";
import Guide from "./components/Guide";
import ContactUs from "./components/ContactUs";
import PolicyPage from "./components/PolicyPage";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path={`${PagePath.PRODUCTDETAIL_PAGE}/:id`}
          element={<ProductDetail />}
        />
        <Route path="/policies/:slug" element={<PolicyPage />} />
        <Route path={PagePath.COOKIE_PAGE} element={<Navigate to="/policies/cookies" replace />} />
        <Route path={PagePath.CONTACT_PAGE} element={<ContactUs />} />
        <Route path={PagePath.SHIPPING_PAGE} element={<Navigate to="/policies/shipping" replace />} />
        <Route path={PagePath.GUIDE_PAGE} element={<Guide />} />
        <Route path={PagePath.JOIN_PAGE} element={<JoinUs />} />
        <Route path={PagePath.PRIVACY_PAGE} element={<Navigate to="/policies/privacy" replace />} />
        <Route path={PagePath.SUBSCRIPTION_PAGE} element={<Subscription />} />
        <Route path={PagePath.SUCCESS_PAGE} element={<Success />} />
        <Route path={PagePath.CHECKOUT_PAGE} element={<Checkout />} />
        <Route path={PagePath.CART_PAGE} element={<Cart />} />
        <Route path={PagePath.TERMS_PAGE} element={<Navigate to="/policies/terms" replace />} />
        <Route path={PagePath.RETURN_PAGE} element={<Navigate to="/policies/returns" replace />} />
        <Route path={PagePath.ABOUT_PAGE} element={<About />} />
        <Route path={PagePath.HOME_PAGE} element={<Home />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
